import './review-sections.css'

interface Journey {
  date: string
  mode: string
  completed: boolean
  depth: string
  arc: string
  outcome: string | null
  key_pivot: string
}

interface RecapData {
  narrative: string
  journeys: Journey[]
  cross_session_threads: string[]
  overall_strategic_evolution: string
}

interface Props {
  data: RecapData
}

export default function RecapSection({ data }: Props) {
  return (
    <div>
      <p className="section-hint">
        A narrative of the strategic questions you explored and how your thinking evolved across sessions.
      </p>

      <p className="section-narrative">{data.narrative}</p>

      {(data.journeys || []).map((journey, i) => (
        <div key={i} className={`journey-card ${!journey.completed ? 'journey-incomplete' : ''}`}>
          <div className="journey-meta">
            <span className="journey-date">{journey.date}</span>
            <span className="journey-mode">{journey.mode}</span>
            <span className="journey-depth">{journey.depth}</span>
            {!journey.completed && <span className="status-pill status-stalled">Abandoned</span>}
          </div>
          <p className="journey-arc">{journey.arc}</p>
          {journey.key_pivot && (
            <div className="journey-pivot">Pivot: {journey.key_pivot}</div>
          )}
          {journey.outcome && (
            <p className="journey-outcome">Outcome: {journey.outcome}</p>
          )}
        </div>
      ))}

      {data.overall_strategic_evolution && (
        <div className="review-card" style={{ marginTop: 12 }}>
          <div className="review-card-header">
            <span className="review-card-title">Strategic Evolution</span>
          </div>
          <p className="review-card-body">{data.overall_strategic_evolution}</p>
        </div>
      )}

      {(data.cross_session_threads || []).length > 0 && (
        <div className="threads-callout">
          <h4>Cross-Session Threads</h4>
          <ul>
            {data.cross_session_threads.map((thread, i) => (
              <li key={i}>{thread}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
